import { ReactElement, useState } from 'react';
import { Button, Popconfirm, message } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useSetAtom } from 'jotai';
import { guardedClient } from '../../../auth/api/clients';
import { recordingsAtom } from '../../list/states/state';

interface Props {
  recordingId: number;
}

const DeleteButton = ({ recordingId }: Props): ReactElement => {
  const navigate = useNavigate();
  const [deleting, setDeleting] = useState(false);
  const refreshRecordings = useSetAtom(recordingsAtom);

  const handleDelete = async () => {
    setDeleting(true);
    try {
      await guardedClient.recordings[':id'].$delete({
        param: { id: String(recordingId) },
      });
      void message.success('削除しました');
      refreshRecordings();
      void navigate('/recordings');
    } catch (error) {
      console.error('delete failed', error);
      void message.error('削除に失敗しました');
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Popconfirm
      title='このレコーディングを削除しますか？'
      onConfirm={() => {
        void handleDelete();
      }}
      okText='削除'
      cancelText='キャンセル'
      okButtonProps={{ danger: true }}
    >
      <Button type='text' danger icon={<DeleteOutlined />} loading={deleting}>
        削除
      </Button>
    </Popconfirm>
  );
};

export default DeleteButton;
